/**
 * @class
 * @classdesc The class RestError is a structure for generic RB API error messages.
 */
import {ErrorResponse} from '../../api/common';

export interface RestErrorParams<T> {
  method: string;
  url: string;
  status: number;
  code: string;
  responseBody?: T;
}

// export class RestError extends Error {
export class RestError<T = ErrorResponse> extends Error {
  type: 'ERROR_REST';
  message: string;
  method: string;
  url: string;
  status: number;
  code: string;
  responseBody?: T;

  constructor(message: string, parameters: RestErrorParams<T>) {
    super(message);
    this.type = 'ERROR_REST';
    this.message = message;
    this.method = parameters.method;
    this.url = parameters.url;
    this.status = parameters.status;
    this.code = parameters.code;
    this.responseBody = parameters.responseBody;
  }
}

export const isRestError = (e: unknown): e is RestError =>
  e !== null && typeof e === 'object' && (e as RestError).type === 'ERROR_REST';

export default RestError;
